
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConnectionOff as ObiConnectionOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-connection-off.js';
 
 
 

 
 export const ObiConnectionOff = createComponent({
   react: React,
   tagName: 'obi-connection-off',
   elementClass: ObiConnectionOffElement,
   events: {
     
   }
  });
 
 